import { render, staticRenderFns } from "./UsuariosFronteraIndex.vue?vue&type=template&id=4449ac18"
import script from "./UsuariosFronteraIndex.vue?vue&type=script&lang=js"
export * from "./UsuariosFronteraIndex.vue?vue&type=script&lang=js"
import style0 from "./UsuariosFronteraIndex.vue?vue&type=style&index=0&id=4449ac18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports